import autobind from 'core-decorators/lib/autobind';
import debounce from 'core-decorators/lib/debounce';

import WixSDK from 'shared/utils/wix-sdk';
import { getCompId } from 'shared/utils/comp-id';
import { REFRESH_EVENT } from 'widget/utils/reload';


/*
 * Since after UOU login or logout, whole site rebuilds, and there is no nice solution in WixSDK for this case.
 * This is workaround, that use persistent events in Wix.PubSub. Anytime we let user login or logout, we also
 * stores data, that we want to path into "next state" of widget after it's reloaded. But since we use
 * persistent events, they are stored in same sequence as we publish them until site is closed or manually refreshed.
 * But we need only last one, that's why we use @debounce for method `processRetrievedData`
 */
export default class ReloadStorage extends React.Component {

  static propTypes = {
    onReload: React.PropTypes.func,
  };

  static defaultProps = {
    onReload: _.noop,
  };

  componentDidMount() {
    this.subscribeId = WixSDK.PubSub.subscribe(
      REFRESH_EVENT,
      this.retrieveDataAfterReload,
      true,
    );

    this.processRetrievedData();
  }

  componentWillUnmount() {
    WixSDK.PubSub.unsubscribe(this.subscribeId);
  }

  stored = null;

  @autobind
  retrieveDataAfterReload({ data }) {
    const compId = getCompId();
    if (data.origCompId === compId) {
      this.stored = data.stored;
      this.processRetrievedData();
    }
  }

  @debounce
  processRetrievedData() {
    if (this.stored) {
      this.props.onReload(this.stored);
    }
    WixSDK.PubSub.unsubscribe(this.subscribeId);
  }

  render() {
    return null;
  }

}



// WEBPACK FOOTER //
// ./src/widget/components/reload-storage/reload-storage.js